import { Toggle } from '@warp-ds/react/components/toggle';
import { getDisplayCurrency } from 'shared/util/money';
import type { PrivateItemPrice } from '@/domain';

type AdditionalServicesSectionProps = {
    privateItemPrice: PrivateItemPrice;
    wantsCleaningService: boolean;
    setWantsCleaningService: (value: boolean) => void;
};

export const AdditionalServicesSection = ({
    privateItemPrice,
    wantsCleaningService,
    setWantsCleaningService,
}: AdditionalServicesSectionProps) => (
    <section className="flex flex-col gap-12 mt-8">
        <h2 className="mb-0 h3">Tilleggstjenester</h2>
        <p>Totalprisen endrer seg når du legger til tjenester. Ta en siste titt før du sender forespørselen.</p>
        <Toggle
            type="checkbox"
            label={`Jeg ønsker å betale for rengjøring (+ ${getDisplayCurrency(privateItemPrice.cleaning.amount)})`}
            checked={wantsCleaningService}
            onChange={setWantsCleaningService}
            data-testid="rentalRequestCleaningService"
        />
    </section>
);
